'use strict';
import { isElement, forEach } from 'lodash';

import { publish } from '../../01-helpers/event-manager';
import { TOGGLE_TRIGGERED } from '../../02-const/event-names';


const moduleName = 'toggle',
    selectors = {
        base: `.js-${moduleName}`
    }

export class Toggle {

    constructor(baseElement) {
        this._config(baseElement);

        this._setup();
    }


    _onClickEventHandler(evt) {
        publish(TOGGLE_TRIGGERED);
    }

    _bindEvents() {
        this.baseElement.addEventListener('click', this._onClickEventHandler);
    }

    _config(element) {
        if (!isElement(element)) {
            return false;
        }

        this.baseElement = element;
    }

    _setup() {
        this._bindEvents();
    }

}

const initToggle = () => {
    forEach(document.querySelectorAll(selectors.base), (toggleElement) => {
        new Toggle(toggleElement);
    });
};

initToggle();